import React from "react";
import classes from "./InfoText.module.scss";

const InfoText = ({ text }) => {
  return <p className={classes.root}>{text}</p>;
};

export default InfoText;
